const setUnactiveRows = (e) => {
    if (e.data) {
        if (e.data.isActive === false && !e.oldData && e.rowType === 'data') {
            e.rowElement.classList.add('dx-row__unactive');
        }
    }
};

export default setUnactiveRows;